var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.59388 6.99413C6.7379 6.97339 6.87202 6.90742 6.97643 6.80537L12.7538 1.22965C12.8999 1.10602 12.9886 0.927218 12.9989 0.735553C13.0096 0.543888 12.9407 0.356371 12.8095 0.216978C12.6779 0.0780001 12.4955 -0.000823257 12.3044 6.45454e-06C12.1137 0.000836166 11.9313 0.0804893 11.8009 0.220712L6.50021 5.33925L1.19948 0.220711C1.06866 0.0804888 0.886263 0.000835675 0.69561 5.9471e-06C0.504957 -0.000823781 0.322145 0.0779996 0.190504 0.216978C0.0592756 0.356371 -0.00963976 0.543887 0.00108906 0.735138C0.0114059 0.926803 0.10013 1.10561 0.246215 1.22924L6.02316 6.80537C6.17502 6.95223 6.38466 7.02151 6.59347 6.99413L6.59388 6.99413Z","fill":"#036483"}));
}

ChevronDown.defaultProps = {"width":"13","height":"7","viewBox":"0 0 13 7","fill":"none"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
